module.exports = __webpack_public_path__ + "static/media/claquete.0ece6e08.svg";